import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { signIn } from "../../api/auth";
import messages from "../shared/AutoDismissAlert/messages";

import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

const SignIn = (props) => {
  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user"));
  //preventing unauthorised users from accessing the page
  // if (token && user) {
  //   window.location.href = "./task-index";
  // }
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const navigate = useNavigate();

  // handleChange = (event) =>
  // 	this.setState({
  // 		[event.target.name]: event.target.value,
  // 	})

  const onSignIn = (event) => {
    event.preventDefault();
    console.log("the props", props);
    const { msgAlert, setLoginUser } = props;

    const credentials = { email, password };

    signIn(credentials)
      .then((res) => {
        // setLoginUser(res.data.user);
        console.log("user", res.data.user);
        localStorage.setItem("token", res.data.user.token);
        localStorage.setItem("user", JSON.stringify(res.data.user));
        localStorage.setItem("userId", res.data.user._id);
        console.log(res.data.user);
      })
      .then(() =>
        msgAlert({
          heading: "Sign In Success",
          message: messages.signInSuccess,
          variant: "success",
        })
      )
      .then(() => {
        navigate("/tasks-index");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        setEmail("");
        setPassword("");
        msgAlert({
          heading: "Sign In Failed with error: " + error.message,
          message: messages.signInFailure,
          variant: "danger",
        });
      });
  };

  return (
    <div className="row">
      <div className="col-sm-10 col-md-8 mx-auto mt-5">
        <h3>Sign In</h3>
        <Form onSubmit={onSignIn}>
          <Form.Group controlId="email">
            <Form.Label>Email address</Form.Label>
            <Form.Control
              required
              type="email"
              name="email"
              value={email}
              placeholder="Enter email"
              onChange={(e) => setEmail(e.target.value)}
            />
          </Form.Group>
          <Form.Group controlId="password">
            <Form.Label>Password</Form.Label>
            <Form.Control
              required
              name="password"
              value={password}
              type="password"
              placeholder="Password"
              onChange={(e) => setPassword(e.target.value)}
            />
          </Form.Group>
          <Button variant="primary" type="submit">
            Submit
          </Button>
        </Form>
        <p>Don't have an account? <a href='sign-up'>Register</a></p>
      </div>
    </div>
  );
};

export default SignIn;
